import React from "react";
import ReactDOM from "react-dom";
import "@babel/polyfill";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

const formParam = {
    channel:"master",
    branch:"Live",
    apiKey:"e44a0363022ba508AABd068a3CF31922473D8f99208A698EbF0A9E31Fa49ED01",
    formId:"665"
}

// const formParam = {
//     channel:"master",
//     branch:"Development",
//     apiKey:"76B5D8a593FbdF4174d67948C0016883d089388Fe5C4Fd00D6ffECE5Ad310C29",
//     formId:"665"
// }

// const formParam = {
//     channel:"master",
//     branch:"Staging",
//     apiKey:"cb1276628e406827c5Acd4A9e568f061A05E7e77a33CC52cfA2e40B3A7A59B44",
//     formId:"665"
// }

ReactDOM.render(<App {...formParam}/>, document.getElementById("app"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
